import React from 'react';

import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuTypePropType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { emptyArray } from 'ui-components/default-props/empty';

const messages = defineMessages({
  selectService: {
    defaultMessage: 'Select Service',
    id: 'gYcC0o',
    description: 'fulfillmentService.selectService',
  },
});

const getFulfillmentServiceName = (fulfillmentServices = [], selectedFulfillmentServiceId) => {
  const found = fulfillmentServices.find((service) => service.id === selectedFulfillmentServiceId);
  return found ? found.name : <FormattedMessage {...messages.selectService} />;
};

export const FulfillmentServiceDropdown = ({
  id,
  dropdownMenuType,
  fulfillmentServices = emptyArray,
  onChange,
  selectedFulfillmentServiceId = null,
  className = '',
}) => (
  <DropdownMenu
    className={className}
    dropdownMenuShouldHaveWidthOfButton
    dropdownMenuType={dropdownMenuType}
    fullWidth
    id={id}
    value={selectedFulfillmentServiceId}
    variant='form'
  >
    <DropdownMenuToggler>{getFulfillmentServiceName(fulfillmentServices, selectedFulfillmentServiceId)}</DropdownMenuToggler>
    <DropdownMenuItem>
      <FormattedMessage {...messages.selectService} />
    </DropdownMenuItem>
    {fulfillmentServices.map(({ id: fulfillmentServiceId, name }) => (
      <DropdownMenuItem
        key={fulfillmentServiceId}
        onClick={() => onChange(fulfillmentServiceId)}
        selected={selectedFulfillmentServiceId === fulfillmentServiceId}
      >
        {name}
      </DropdownMenuItem>
    ))}
  </DropdownMenu>
);

FulfillmentServiceDropdown.propTypes = {
  id: PropTypes.string,
  dropdownMenuType: DropdownMenuTypePropType,
  className: PropTypes.string,
  fulfillmentServices: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    }),
  ),
  selectedFulfillmentServiceId: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
